import { LocalStorageKey } from '@/constants/localstorage'
import { useLocalStorage } from 'usehooks-ts'

export const useEnteringModeValue = () => {
  const [enteringMode, setEnteringMode] = useLocalStorage<EnteringMode>(
    LocalStorageKey.EnteringMode,
    EnteringMode.Unknown
  )

  const clear = () => {
    setEnteringMode(EnteringMode.Unknown)
  }

  return { enteringMode: EnteringMode.Unknown, clear }
}

export enum EnteringMode {
  Unknown = 'unknown',
  DepositBonus100 = 'deposit-bonus-100',
  Login = 'login',
}

export const enteringModeResolver = (mode: string) => {
  switch (mode) {
    case 'login':
      return EnteringMode.Login
    case 'deposit-bonus-100-usd':
      return EnteringMode.DepositBonus100
  }

  return EnteringMode.Unknown
}
